/* eslint-disable @typescript-eslint/no-this-alias */
import { Injectable } from '@angular/core';
import { AppConsts } from 'src/shared/AppConsts';
import { HostSettingsServiceProxy } from 'src/shared/service-proxies/service-proxies';

@Injectable({
  providedIn: 'root', // This makes the service available globally
})
export class AppAuthenticationService {
  constructor(private _hostSettingService: HostSettingsServiceProxy) {}

  init(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const self = this;

      self._hostSettingService.getAllSettings().subscribe(setting => {
        AppConsts.appActiveDirectoryEnabled = setting.azureActiveDirectory.isModuleEnabled && setting.azureActiveDirectory.isEnabled;
        AppConsts.appLdapEnabled = setting.ldap.isModuleEnabled && setting.ldap.isEnabled;
        AppConsts.googleAnalytics = setting.google.analytics;
        AppConsts.googleTagManager = setting.google.tag;
        AppConsts.recaptchaSiteKey = setting.google.recaptchaSiteKey;
        resolve(true);
      });
    });
  }
}
